var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "ma-5 d-flex flex-column invitation-code-card",
      attrs: { flat: "" },
    },
    [
      _c(
        "v-card-text",
        { staticClass: "flex-grow-1 pa-0 d-flex flex-column" },
        [
          _vm.invitationCodes.length
            ? _c(
                "v-list",
                {
                  staticClass:
                    "invitation-list pa-0 flex-grow-1 d-flex flex-column",
                },
                [
                  _c("v-virtual-scroll", {
                    staticClass: "flex-grow-1",
                    attrs: {
                      items: _vm.invitationCodes,
                      "item-height": 48,
                      height: _vm.scrollHeight,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "selectable-text",
                                  attrs: {
                                    color: "primary",
                                    "input-value": _vm.selected === item,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.selected = item
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "code-text" },
                                        [_vm._v(" " + _vm._s(item) + " ")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-action",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.copyCode(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-content-copy")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      53530027
                    ),
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "empty-state pa-8 text-center" },
                [
                  _c(
                    "v-icon",
                    { attrs: { size: "48", color: "grey lighten-1" } },
                    [_vm._v("mdi-ticket-outline")]
                  ),
                  _c("p", { staticClass: "mt-4 grey--text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("no-invitation-codes") || "No invitation codes"
                        ) +
                        " "
                    ),
                  ]),
                ],
                1
              ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-actions",
        { staticClass: "pa-3" },
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: {
                disabled:
                  !_vm.selected || !_vm.invitationCodes.includes(_vm.selected),
                color: "error",
                text: "",
              },
              on: { click: _vm.deleteOne },
            },
            [
              _c("v-icon", { attrs: { left: "", small: "" } }, [
                _vm._v("mdi-delete"),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("delete")) + " "),
            ],
            1
          ),
          _c(
            "v-btn",
            { attrs: { color: "primary" }, on: { click: _vm.create } },
            [
              _c("v-icon", { attrs: { left: "", small: "" } }, [
                _vm._v("mdi-plus"),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("create")) + " "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }